import _ from 'underscore';
import getDefaultName from '../defaults/get-default-name';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import AppPerformanceMetricsColumns from '../common-columns/app-performance-metrics-columns';
import PhonePerformanceMetricsColumns from '../common-columns/phone-performance-metrics-columns';
import SOVColumns from '../common-columns/sov-columns';
import SOVLostColumns from '../common-columns/sov-lost-columns';
import AudienceSOVColumns from '../common-columns/audience-sov-columns';
import QualityScoreColumns from '../common-columns/quality-score-columns';
import getDefaultRoute, { getDefaultRouteForNewUI } from '../defaults/get-default-route';

const BudgetGridQueryStringRegex = /\$expand=Budget&BudgetId=(\d+)/;

export function getName({
  QueryString = '',
  PerformanceTargetInstanceId,
} = {}) {
  if (_.isNumber(PerformanceTargetInstanceId)) {
    return getDefaultName('PerformanceTargetOverview');
  }
  if (BudgetGridQueryStringRegex.test(QueryString)) {
    return 'SharedBudgetEditGrid';
  }
  return getDefaultName('Campaign');
}

function getCampaignGridColumnsMetadata() {
  return _.defaults(
    {
      Budget: 'Budget/Amount',
      CampaignId: 'Id',
      CampaignStatus: 'Status',
      DisplayBiddingStrategyType: 'BiddingScheme',
      Languages: 'Languages',
      CashbackScope: 'CampaignCashback/Scope',
      CashbackPercent: 'CampaignCashback/Percent',
      CashbackBudget: 'CampaignCashback/MonthlyBudget',
      Coupon: 'CampaignCashback/CouponsEnabled',
    },
    PerformanceMetricsColumns,
    AppPerformanceMetricsColumns,
    PhonePerformanceMetricsColumns,
    SOVColumns,
    SOVLostColumns,
    QualityScoreColumns,
    AudienceSOVColumns
  );
}

function getPerformanceTargetsCampaignGridColumnsMetadata() {
  return _.defaults(
    {
      Budget: 'Budget/Amount',
      CampaignId: 'Id',
      CampaignStatus: 'Status',
      Delivery: 'DeliveryStatus',
      DisplayBiddingStrategyType: 'BiddingScheme',
    },
    PerformanceMetricsColumns,
    PhonePerformanceMetricsColumns,
    SOVColumns,
    SOVLostColumns,
    QualityScoreColumns,
    AudienceSOVColumns
  );
}

function getBudgetGridColumnsMetadata() {
  return _.defaults({
    CampaignName: 'Name',
    BudgetStatus: 'BudgetAssociationStatus',
  }, PerformanceMetricsColumns);
}

export function getColumnsMetadata({
  QueryString = '',
  PerformanceTargetInstanceId,
} = {}) {
  if (_.isNumber(PerformanceTargetInstanceId)) {
    return getPerformanceTargetsCampaignGridColumnsMetadata();
  }

  return BudgetGridQueryStringRegex.test(QueryString) ?
    getBudgetGridColumnsMetadata() :
    getCampaignGridColumnsMetadata();
}

export function getRoute(selection) {
  const {
    QueryString = '',
    PerformanceTargetId,
    PerformanceTargetInstanceId,
  } = selection;

  if (_.isNumber(PerformanceTargetInstanceId)) {
    return `customer/:customer_id/account/:account_id/performance_target/${PerformanceTargetId}/instance/${PerformanceTargetInstanceId}`;
  }

  const match = BudgetGridQueryStringRegex.exec(QueryString);

  if (match) {
    return `customer/:customer_id/account/:account_id/library/sharedbudget/${match[1]}/edit`;
  }

  return getDefaultRoute('Campaign', selection);
}

export function getRouteForNewUI(options) {
  const { getUrlSearch, selection } = options;
  const {
    QueryString = '',
    PerformanceTargetId,
    PerformanceTargetInstanceId,
  } = selection;

  if (_.isNumber(PerformanceTargetInstanceId)) {
    return `performancetargets/overview${getUrlSearch({ ptId: PerformanceTargetId, instanceId: PerformanceTargetInstanceId })}`;
  }

  const match = BudgetGridQueryStringRegex.exec(QueryString);

  if (match) {
    return `sharedbudgets/edit${getUrlSearch({ budgetId: match[1] })}`;
  }

  return getDefaultRouteForNewUI(options);
}
